import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import UserCompensationCard from '../components/report/UserCompensationCard';

const Giveaway = ({ admin, token }) => {

	const history = useHistory();

	const [toggled, setToggled] = useState(false)

	useEffect(() => {
		if (!admin || !admin.user_reward) history.push("/admin/dashboard");
	}, [])

	return (
		<div className="admin-page-container">
			<Sidebar toggled={toggled} setToggled={e => setToggled(!toggled)} />
			<div className="admin-page">
				<Topbar handleToggle={e => setToggled(!toggled)} />
				<div className="admin-content">
					<UserCompensationCard
						authtoken={token}
						stamp={admin?.stamp}
						etoken={admin?.token}
						point={admin?.loyalty_point}
						role="operator"
						country={admin?.country}
					/>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = state => {
	return {
		admin: state.admin.admin,
		token: state.admin.token
	};
};

export default connect(mapStateToProps, null)(Giveaway);
